import { type PublicEnv, publicEnvKeys, publicEnvSchema } from "./publicEnvSchema";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function getSource(): Record<string, unknown> {
  const ret =
    typeof window === "undefined" ? process.env : JSON.parse(document.documentElement.dataset.agoraPublicEnv ?? "{}");

  if (!isRecord(ret)) {
    throw new Error(`[publicEnv] invalid config source: ${typeof ret}`);
  }

  return ret;
}

const source = getSource();

const raw = Object.fromEntries(publicEnvKeys.map((key) => [key, source[key]]));

const parsed = publicEnvSchema.safeParse(raw);
let parsedData: PublicEnv;

// `next build` evaluates this module against CI's environment, which is deliberately
// incomplete because env vars are not available at the time of build.
// Anywhere else, config that fails its schema is a real fault: scripts/guard-envs.ts
// stops the server before it can reach here.
if (parsed.success) {
  parsedData = parsed.data;
} else if (process.env.NEXT_PHASE === "phase-production-build") {
  parsedData = raw as PublicEnv;
} else {
  const detail = parsed.error.issues.map((i) => `${i.path.join(".")}: ${i.message}`).join("; ");
  throw new Error(`[publicEnv] invalid config: ${detail}`);
}

export const publicEnv: PublicEnv = parsedData;
